<template>
  <v-container fluid>
    <admin-broker-detail-search
      class="mt-1 mb-1"
      :loading="loading"
      @search="searchBroker"
    />

    <v-data-table
      :headers="filteredHeaders"
      :items="filteredItemsList"
      :loading="loading"
      :search="search"
      :hide-default-footer="hideFooter"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <template #[`item.too_aktyvus`]="{ item }">
        <el-switch v-model="item.too_aktyvus" />
      </template>
      <template #[`item.too_tekstas`]="{ item }">
        <div class="text-cut-4">
          <span v-html="item.too_tekstas"></span>
        </div>
      </template>
      <template #[`item.aktyvus_label`]="{ item }">
        <el-busena :busena="item.aktyvus_label" :color="item.aktyvus_color" />
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import AdminBrokerDetailSearch from './AdminBrokerDetailSearch'
export default {
  name: 'AdminTooltipDetail',
  props: {
    grupe: String,
  },
  components: {
    AdminBrokerDetailSearch,
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      brokerList: [],
      search: null,
      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      searchData: {},
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Duomenu gavėjas',
          align: 'start',
          sortable: false,
          value: 'wsa_duomenu_gavejas_title',
        },
        {
          text: 'IP',
          align: 'start',
          sortable: false,
          value: 'wsa_ip',
        },
        {
          text: 'Parametrai',
          align: 'start',
          value: 'wsa_parametrai',
        },
        {
          text: 'Atsakymas',
          align: 'start',
          value: 'wsa_atsakymas',
        },
        {
          text: 'Data',
          align: 'start',
          value: 'wsa_sukurimo_data',
        },
        {
          text: 'Klaida',
          align: 'start',
          value: 'wsa_klaida',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    filteredItemsList() {
      return this.itemsList.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.brokerList.map(item => {
        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    isSearch() {
      return this.search != null && this.search.length > 0
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    modalTooltipKey() {
      return 'broker-' + this.modalTooltipRefresh
    },
  },
  created() {
    //this.getData(true)
  },
  methods: {
    searchBroker(searchData) {
      this.searchData = searchData
      this.getData()
    },
    getData(resetPageNr = false) {
      this.pageloading = true
      this.loading = true

      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        savitarna: this.grupe === 'savitarna',
        search: this.searchData,
      }

      this.$axios
        .post(`admin/brokeris/list`, data)
        .then(res => {
          this.brokerList = res.data.logai
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
  },
}
</script>
